/* src/app/components/dialogs/select-fields/select-fields.component.scss */
mat-dialog-content {
  display: flex;
  flex-direction: row;
}
mat-form-field[appearance=outline] {
  --outlined-text-field-outline-color: #a8a8a8;
}
:host-context(.dark-theme) mat-form-field[appearance=outline] {
  --outlined-text-field-outline-color: rgba(255,255,255,0.4);
}
mat-form-field.custom-label-float-above-position {
  --top: 22px;
}
::ng-deep mat-list-option .mdc-list-item__primary-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.column {
  margin: 20px 10px 0px 10px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.sub-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.mat-mdc-dialog-title {
  padding: 24px 24px 24px 20px;
  margin: -24px -24px 10px -24px;
  background-color: rgb(48, 63, 159);
  color: white;
}
.field-group-container {
  box-sizing: border-box;
  cursor: move;
  display: block;
  vertical-align: top;
}
.field-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.field-container {
  height: 300px;
  width: 350px;
  overflow: auto;
  border: solid 2px #ccc;
  border-radius: 4px;
  display: block;
}
.group-text:hover {
  background-color: #EEEEEE;
  background-color: var(--lexbe-theme-gray-200, #EEEEEE);
}
.group-text-line {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow:
    0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14),
    0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.cdk-drag-placeholder {
  opacity: 0;
}
.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.action-container {
  justify-content: space-between;
}
:host-context(.dark-theme) .group-text:hover {
  background-color: rgba(255, 255, 255, 0.0784313725);
}
:host-context(.dark-theme) .field-container {
  border: solid 2px #656565;
}
/*# sourceMappingURL=select-fields.component.css.map */
